<template>
    <section class="content">
        <div class="container-fluid">
                <div class="card">
                    <div class="fn-header">
                        การจัดการแพคเกจ 
                    </div>

                   
                   <div class="row search-section">
                        <div class="col-sm-2 col-search">
                             
                             <button type="button" class="btn bg-teal waves-effect btn-search"   @click="addPackage()">
                                 <i class="material-icons">add_box</i>
                                 <span>สร้างแพคเกจ</span>
                             </button>
                        
                        </div>
                        <div class="col-sm-5 col-search"></div>
                        <div class="col-sm-2 col-search">
                            <input type="text" class="search-textbox" v-model="key" placeholder="กรุณากรอกชื่อแพคเกจ เพื่อค้นหา" style="width:100%;margin-top:5px" >
                        </div>
                        
                        <div class="col-sm-2 col-search">
                            <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching" @click="search(1)">
                                <i class="material-icons">search</i>
                                <span>ค้นหา</span>
                            </button> 
                        </div>
                        <div class="col-sm-1 col-search">
                            <button type="button" class="btn bg-grey waves-effect btn-search"  :disabled="searching" @click="reset()">
                                <i class="material-icons">refresh</i>
                                <span>Reset</span>
                            </button> 
                        </div>  
                        
                    </div>
                    <div class="row ">
                        <div class="col-sm-12 " style="text-align: right;">
                            <img src="static/images/excel.png" class="excel-icon" style="margin-right: 15px;cursor: pointer;" @click="download()"/>
                        </div>
                    </div>
                    <div class="body table-responsive" style="width:100%" >
                        <div class="preloader pl-size-xl"  v-if="searching == true || loading == true">
                            <div class="spinner-layer pl-orange">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    <div v-else>
                       
                       
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="fn-th">แพคเกจ</th>
                                    <th class="fn-th">ราคา</th>
                                    <th class="fn-th">กำไร</th>
                                    <th class="fn-th">วันที่สร้าง</th>
                                    <th class="fn-th">วันที่แก้ไข</th>
                                    <th class="fn-th">สถานะ</th>
                                    <th class="fn-th">ผู้บันทึก</th>
                                    <th class="fn-th">แก้ไข</th>
                                    <th class="fn-th">ลบ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in items" :key="'p-' + item.package_id" :class="{'fn-tr-light' : index % 2 ,'fn-tr-dark' : !(index % 2) }">
                                    <!-- <td v-html="((page-1) * perpage) + index + 1"></td> -->
                                    <td style="text-align: center;">
                                        
                                            <span>{{ item.package_name }}</span>
                                        
                                    </td>
                                    
                                    <td style="text-align: center;">
                                         <span>{{ item.price | comma }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                         <span>{{ item.profit }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.create_datetime | date }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.update_datetime | date }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.active == 1 ? 'Active' : 'Inactive' }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.name }}</span>
                                    </td>
                                    
                                   
                                    
                                     <td>
                                            <span @click="editPackage(item.package_id)">
                                                <a href="#">
                                                    <i class="material-icons fn-icon">mode_edit</i>
                                                </a>
                                            </span>
                                    </td>
                                    <td>
                                        <span @click="deletePackage(item.package_id)">
                                                <a href="#">
                                                    <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                                </a>
                                            </span>
                                    </td>
                                   
                                </tr>
                            </tbody>
                           
                        </table>
                    </div>

                        <Paginate
                            v-model=page
                            :page-count=pages
                            :page-range="5"
                            :click-handler="search"
                            :prev-text="'Prev'"
                            :next-text="'Next'"
                            :container-class="'fn-pagination'"
                        />

                        
                    </div>
                </div>
        </div>
        <div class="modal fade" id="package-modal" tabindex="-1" role="dialog" >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">
                    
                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">สร้างแพคเกจ</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>แพคเกจ</span>
                        </div>
                        <div class="col-sm-10">
                            <div style="float: left;margin-top: 5px;"  v-if="package.package_id > 0">{{ package.package_name }}</div>
                            <input type="text" class="form-control" v-model="package.package_name" placeholder="" v-else>
                        </div>
                    </div>
                    
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา</span>
                        </div>
                        <div class="col-sm-6">
                            <input type="number" v-model="package.price" class="form-control " placeholder="">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>กำไร</span>
                        </div>
                        <div class="col-sm-6">
                            <input type="number" v-model="package.profit" class="form-control " placeholder="">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>สถานะ</span>
                        </div>
                        <div class="col-sm-6">
                            <select  class="form-control  show-tick fn-required" v-model="package.active">
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>
                    </div>
                    
                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;" @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"  data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { PackageService } from '../../service'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name : "ManagePackage",
    components: {
        DatePicker,
        Paginate
    },
    data(){
        return {
            user:JSON.parse(localStorage.getItem('user')),
            page : 1,
            perpage : 50,
            total : 0,
            pages : 0,
            block_set : 5,
            block_index : 0,
            blocks : [],
            items: [],
            package: {},
            key:"",
            searching:false,
            loading : false,
            search_params:{}
        }
    },
    async created() {
     
        this.search(1)
    },
    mounted(){

    },
    methods: {
        
        async search(p = 0){
             if(p > 0){
                this.page = p
            }
            this.loading = true
            
            let response = await PackageService.search(this.key,this.page,this.perpage)
        
            if(response.status)
            {
                let{page,perpage,total,pages,data} = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data
                
            }
            this.loading = false
        },
        reset(p = 1){
            this.key = ""
            this.search(p)
        },
        addPackage(){
            this.package ={
                package_id :0,
                package_name: "",
                price:"",
                profit:0,
                create_datetime:"",
                update_datetime:"",
                active: "1",
                update_by: this.user.id
            }
            $('#package-modal').modal('show')
        },
        editPackage(id){
            this.package = this.items.find(x => x.package_id == id)
            this.package.update_by = this.user.id
            $('#package-modal').modal('show')
        },
        async handleSave(){
            if(!this.validate()){
                return false
            }

            if(this.package.package_id == 0){
                await this.create()
            }
            else{
                await this.update()
            }
            
            $('#package-modal').modal('hide')
        },
        validate(){
            if(!this.package.package_name){
                alertBox.error("กรุณากรอก package")
                    return false
            }
            if(!this.package.price){
                alertBox.error("กรุณากรอกราคา")
                    return false
            }
            if(!this.package.profit){
                alertBox.error("กรุณากรอกกำไร")
                    return false
            }
            
            return true
        },
        async create(){
            try{
              
                let response = await PackageService.create(this.package)
               
                if(response.status){
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else{
                    alertBox.error("Error, " + response.error)
                }
            }
            catch(error){
                alertBox.error("Error, " + error)
            } 
        },
        async update(){
            try{
                let response = await PackageService.update(this.package)
                if(response.status){
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else{
                    alertBox.error("Error, " + response.error)
                }
            }
            catch(error){
                alertBox.error("Error, " + error)
            } 
        },
        deletePackage(id){
            var vm = this
            alertBox.confirm('คุณแน่ใจที่จะลบ?').then(async function(result){
                if (result) {
                    var response = await PackageService.delete(id)
                   
                    if(response.status){
                      vm.reset(vm.page  )
                    }
                    else{
                        alertBox.error("Error, " + response.error)
                    }
                }
            })
        },
        download(){
            let url = `${process.env.API}/package/download`
            let fileName = 'การจัดการแพคเกจ_' + moment(this.date).format('YYYYMMDD_HHmmss') +'.xlsx'
            let key = this.key
          
            var request = new XMLHttpRequest();
            request.onload = function(e) {
                if (this.status === 200) {
                    
                        var blob = this.response;
                        if(window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveBlob(blob, fileName);
                            
                        }
                        else{
                            var downloadLink = window.document.createElement('a');
                            var contentTypeHeader = request.getResponseHeader("Content-Type");
                            downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
                            downloadLink.download = fileName;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                            
                        }
                    
                }
                else{
                    alertBox.error("Error ,Can not download")
                    
                }
               
            };
            
            request.open('POST', url);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            request.setRequestHeader('Access-Control-Allow-Origin', '*');
            request.responseType = 'blob';
            request.send(`key=${key}`);
        },
      
    },
    filters:{
        comma(value) {
            return helper.WithComma(value)
        },
        date(value){
            if(!value) return ""

            return  moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped>
    
    .link{
        font-weight: bold;
    }
    .p-title{
        text-align: left;
        font-weight: bold;
        margin-bottom: 15px;
    }
    .p-price{
        text-align: right;
        padding-right: 30px;
    }
    /* .table-bordered thead tr th{
        padding: 8px;
        border: 1px solid #eee;
    }
    .table-bordered tbody tr td{
        padding: 5px;
        padding-top: 5px;
        border: 1px solid #eee
    } */

</style>


// WEBPACK FOOTER //
// src/components/Manage/Package.vue